const isValidWebsiteUrl = (url: string) =>
  /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?$/.test(url);

export default isValidWebsiteUrl;
